module.exports = __webpack_public_path__ + "media/images/icons/icon_exp_black-09c0265f188655f09692c192b5c1d27a.svg";